import React, { useEffect, useState } from 'react'
import './DotProgressBar.scss'
/**
 * Represents a Dot Progress Bar component
 *
 * @component
 * @example
 * <DotProgressBar currentIndex={1} progressBarItems={['Enter Details', 'Confirmation', 'Trade-In Value']} />
 */
const DotProgressBar = ({
  currentIndex,
  progressBarItems,
  showStepCount,
  showEveryStepCount,
  classNames = {},
  reference,
  onDotClick,
  showTick = false,
}) => {
  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth > 767)

  useEffect(() => {
    const handleOnResize = () => {
      setIsMobileScreen(window.innerWidth > 768)
    }
    window.addEventListener('resize', handleOnResize)
    return () => {
      window.removeEventListener('resize', handleOnResize)
    }
  }, [])

  return (
    <div className={`dot-progress-bar-container-new ${classNames.container || ''}`} ref={reference}>
      {progressBarItems.map((item, index) => (
        <div className={`dot-item-new  ${index <= currentIndex ? 'active' : ''} ${classNames.item || ''}`} key={index}>
          <div
            className={`dot-icon-new ${showTick ? 'dot-tick-new' : ''}  ${onDotClick && index <= currentIndex ? 'cursor-pointer' : ''} ${
              index !== progressBarItems.length - 1 && showStepCount && index === currentIndex ? 'current' : ''
            } ${classNames.icon || ''}`}
            onClick={index <= currentIndex ? () => onDotClick({ item, index }) : undefined}
          >
            {showEveryStepCount && <span className={index > currentIndex ? 'not-visited-number-new' : ''}>{index + 1}</span>}
            {index === currentIndex && showStepCount && <span>{currentIndex + 1}</span>}
            <span className={`${index === currentIndex ? 'dot-circle-new' : ''}`}></span>
          </div>
          {<div className={`jost-font dot-description-new ${classNames.description || ''}`}>{item}</div>}{' '}
        </div>
      ))}
    </div>
  )
}
export default DotProgressBar
